@if (showInfoCard === true) {
    <div class="card qai-card p-5 qai-card-bg d-flex flex-row align-items-center mb-5">
        <div class="col-10">
            <h2 class="text-primary mb-3">{{ name() }}</h2>

            <ng-content></ng-content>

            <!-- <button type="button" class="mt-4 btn btn-primary te-outline-primary" i18n [routerLink]="'/contexts/new'">
                    Crea
                </button> -->
        </div>
        <div class="position-absolute top-0 end-0 p-3">
            <button type="button" class="btn-close rounded-pill" i18n-aria-label aria-label="Close"
                (click)="showInfoCard = false"></button>
        </div>
    </div>
}